{{#if local}}
<div class="redirect-content">
  <div class="redirect-content-inner">
    If you weren't local you'd be redirect to assessment: <code>{{assessment_slug}}</code>
    <div>
      <a class="btn btn-default" href="#" data-local-action="fail">Fail the Exam</a>
      <a class="btn btn-default" href="#" data-local-action="pass">Pass the Exam</a>
    </div>
  </div>
</div>
{{else}}
<div class="redirect-content">
  <div class="redirect-content-inner">
    {{t "assessmentRedirect"}}
  </div>
</div>
{{/if}}